import { ReactElement } from 'react';
import { Text, TextProps } from '@chakra-ui/react';

const IsRequiredStar = ({
  color = 'red',
  ...props
}: TextProps): ReactElement => (
  <Text display='inline' color={color} ml={1} {...props}>
    *
  </Text>
);

export default IsRequiredStar;
